/**
 * Venue filter values are encoded as `${data_id}:${product_id}` — both are
 * colon-free datahub slugs, so the pair round-trips through a single ":"-joined
 * string. Keeping encode/decode here keeps the chart engine, the filter picker,
 * and the filter chip consistent (they previously each split the string by hand).
 */
export function encodeVenue(dataId: string, productId: string): string {
  return `${dataId}:${productId}`
}

export function parseVenue(value: string): {
  dataId: string
  productId: string
} {
  const separatorIndex = value.indexOf(":")
  if (separatorIndex === -1) {
    return { dataId: value, productId: "" }
  }
  return {
    dataId: value.slice(0, separatorIndex),
    productId: value.slice(separatorIndex + 1),
  }
}
